import ErrorIcon from '@mui/icons-material/ErrorOutline';
import Link from 'next/link';
import React from 'react';
import styles from './AccountIdErrorMessage.module.scss';
const AccountIdErrorMessage: React.FC = () => {
  const urgentCareCentersLink = process.env.NEXT_PUBLIC_WELLNOW_URGENT_CARE_CENTERS;
  return <div className={styles['error-container']} data-sentry-component="AccountIdErrorMessage" data-sentry-source-file="AccountIdErrorMessage.tsx">
			<ErrorIcon className={styles['error-icon']} data-sentry-element="ErrorIcon" data-sentry-source-file="AccountIdErrorMessage.tsx" />
			<div className={styles['error-content']}>
				<span className={styles['error-text']}>
					This location is currently unavailable for online scheduling.{' '}
				</span>
				{urgentCareCentersLink && <Link href={urgentCareCentersLink ? urgentCareCentersLink : '#'} className={styles['error-link']} target="_blank" rel="noopener noreferrer">
						Please try selecting a different location
					</Link>}
			</div>
		</div>;
};
export default AccountIdErrorMessage;